
export async function getGpxs(fileName: string) {
  const result = await fetch(fileName)
    .then((response) => response.text());
  return result;
}
